// enter를 인식시키기 위해, 사용 시 whiteSpace pre-line 설정 필요

export const LEGAL_TEXTS = {
  COMPARISON_PRICE: 
    `※ 장례식장 예상 빈소 이용료는 e하늘 장사정보시스템(보건복지부) 자료를 기반으로 산출한 참고용 자료입니다.
    ※ 금액은 단순 비용 비교를 위한 정보 제공 목적이며, 특정 장례식장의 우열을 의미하지 않습니다.`,
  COMPARISON_FACILITY: 
    `※ 장례식장 예상 빈소 이용료는 e하늘 장사정보시스템(보건복지부) 자료를 기반으로 산출한 참고용 자료입니다.
    ※ 시설 정보는 단순 비용 비교를 위한 정보 제공 목적이며, 특정 장례식장의 우열을 의미하지 않습니다.`,
  COST_VARIABILITY:
    `※ 예상 빈소 이용료는 보건복지부 e하늘 장사정보시스템 자료를 바탕으로 산출한 참고용 가이드입니다.
    ※ 실제 비용은 장례 시점에 따라 달라질 수 있습니다.`,
  FIFTY_GUESTS:
    `※ 본 예상 금액은 보건복지부 e하늘 장사정보시스템 자료를 바탕으로 산출한 참고용 가이드입니다.
    ※ 조문객 50명에 적합한 66평 미만 빈소를 기준으로 산정했으며, 안치·염습·제단·음식 등 주요 항목의 예상 비용을 포함합니다.
    ※ 실제 비용은 장례식장 상황, 시기, 조문객 수 등에 따라 달라질 수 있습니다.`,
  UNRELATED:
    `※ 예상 빈소 이용료는 보건복지부 e하늘 장사정보시스템 자료를 바탕으로 산출한 참고용 가이드입니다.
    (주) 고이장례연구소는 시설과 무관합니다.`
}